module.exports = __webpack_public_path__ + "img/zhifubao.81b4df98.png";